import React, { useEffect } from "react";
import "../styles.css";
import ContainerBody from "../components/ContainerBody";
import ButtonLink from "../components/ButtonLink";
import ContainerNav from "../components/ContainerNav";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import ContainerRoot from "../components/ContainerRoot";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper/core";
import { useTranslation } from "react-i18next";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";

// install Swiper modules
SwiperCore.use([Navigation]);

export default function Prompt(props) {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(props.language);
  }, [i18n, props.language]);

  const predefinedPrompts = [
    t("example_prompt.1"),
    t("example_prompt.2"),
    t("example_prompt.3"),
    t("example_prompt.4"),
    t("example_prompt.5"),
    t("example_prompt.6"),
    t("example_prompt.7"),
    t("example_prompt.8"),
    t("example_prompt.9"),
  ];
  const handleInputChange = (key, value) => {
    props.setPrompt({ ...props.prompt, [key]: value });
  };

  const handleTipClick = (tip) => {
    props.setPrompt({
      ...props.prompt,
      prompt: tip,
    });
  };

  return (
    <ContainerRoot>
      <ContainerBody>
        <Typography>{t("Custom Prompt")}</Typography>
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={6}>
            <Swiper navigation={true} spaceBetween={50}>
              {predefinedPrompts.map((tip, index) => (
                <SwiperSlide
                  key={index}
                  className="aaaaaaa"
                  style={{ right: "-12%" }}
                >
                  <Card sx={{ maxWidth: 245, alignItems: "center" }}>
                    <CardContent>
                      <Typography variant="caption">{tip}</Typography>
                    </CardContent>
                    <CardActions>
                      <Button
                        size="small"
                        onClick={() => handleTipClick(tip)}
                        variant="outlined"
                      >
                        {t("Add")}
                      </Button>
                    </CardActions>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography>{t("Enter your prompt")}</Typography>
            <TextField
              placeholder="Prompt"
              size="small"
              fullWidth
              multiline
              rows={16}
              value={props.prompt.prompt}
              onChange={(event) =>
                handleInputChange("prompt", event.target.value)
              }
            />
          </Grid>
        </Grid>
      </ContainerBody>
      <ContainerNav>
        <ButtonLink url="/image" title={t("Back")} />
        <ButtonLink url="/debug" title={t("Next")} color="primary" />
      </ContainerNav>
    </ContainerRoot>
  );
}
